import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import type { PurchasablePlan } from 'src/components/AzarOnly/Subscription/utils/formatSubscription';
import { formatPrice } from 'src/components/AzarOnly/Subscription/utils/formatSubscription';
import { DiscountBadge, ShopBadgeLabel } from 'src/components/Shop/ShopLabels';
const CardContainer = styled.div`
  background: ${({
  theme
}) => theme.color.surface3};
  border: 2px solid ${({
  theme
}) => theme.color.surfaceDeep};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-block: 20px;
`;
const BadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const PriceRow = styled.div<{
  $isBold?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 18px;
  line-height: 24px;
  color: ${({
  theme
}) => theme.color.content12};
  font-weight: ${({
  $isBold
}) => $isBold ? 700 : 400};
`;
const PriceLabel = styled.span`
  flex: 1;
`;
interface Props {
  planModule: PurchasablePlan['planModule'];
  pgIntroductoryOfferEligible: boolean;
}
const PlanCard: FC<Props> = ({
  planModule,
  pgIntroductoryOfferEligible
}) => {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    pgPrice,
    introductoryPgPrice,
    introductoryDisplayDiscountRate,
    badge
  } = planModule;
  const hasBadges = introductoryDisplayDiscountRate || badge?.text;
  return <CardContainer data-sentry-element="CardContainer" data-sentry-component="PlanCard" data-sentry-source-file="PlanCard.tsx">
      {hasBadges && <BadgesRow>
          {badge && <ShopBadgeLabel {...badge} />}
          {introductoryDisplayDiscountRate && <DiscountBadge>
              {badge ? '+ ' : ''}
              {t('common_discount_off', {
          percentage: introductoryDisplayDiscountRate
        })}
            </DiscountBadge>}
        </BadgesRow>}
      {pgIntroductoryOfferEligible && introductoryPgPrice ? <>
          <PriceRow $isBold>
            <PriceLabel>{t('shop.subs_purchase_modal_price_first')}</PriceLabel>
            {formatPrice(introductoryPgPrice, i18n.language)}
          </PriceRow>
          <PriceRow>
            <PriceLabel>{t('shop.subs_purchase_modal_price_renewal')}</PriceLabel>
            {formatPrice(pgPrice, i18n.language)}
          </PriceRow>
        </> : <PriceRow>
          <PriceLabel>{t('shop.subs_purchase_modal_price')}</PriceLabel>
          {formatPrice(pgPrice, i18n.language)}
        </PriceRow>}
    </CardContainer>;
};
export default PlanCard;